import { defineMessages } from 'react-intl';

export default defineMessages({
  activating: {
    id: 'cboard.components.Activate.activating',
    defaultMessage: 'Activating your account...'
  },
  loginSignUpPage: {
    id: 'cboard.components.Activate.LoginSignUpPage',
    defaultMessage: 'Login or sign up page'
  },
  error: {
    id: 'cboard.components.Activate.error',
    defaultMessage:
      'ERROR: confirming your temporary user FAILED, please try to login again'
  },
  success: {
    id: 'cboard.components.Activate.success',
    defaultMessage: 'CONFIRMED!'
  }
});
